import { defineAction } from 'redux-define'

const states = ['FULFILLED', 'REJECTED', 'CANCELLED']
export const namespace = 'user'

export const GET_USER = defineAction('GET_USER', states, namespace)
export const GET_USER_JOB_TITLE = defineAction(
  'GET_USER_JOB_TITLE',
  states,
  namespace
)

export const FIND_ENTITY_NAME = defineAction(
  'FIND_ENTITY_NAME',
  states,
  namespace
)
